import {Component, computed, inject, input, signal} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {ExternalLinkIcon, HouseIcon, LucideAngularModule, MessageSquareMoreIcon} from 'lucide-angular';
import {VenuePipe} from '@domain/venue/pipe/venue.pipe';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {RouterLink} from '@angular/router';
import {HostContactForm} from '@domain/host/host-contact-form/host-contact-form.component';
import {ScrollManagerService} from '@core/service/scroll-manager.service';
import {ScrollTargetDirective} from '@domain/common/directive/scroll-target.directive';

@Component({
  selector: 'app-activity-host',
  providers: [
    VenuePipe
  ],
  imports: [
    TranslocoDirective,
    LucideAngularModule,
    RouterLink,
    HostContactForm,
    ScrollTargetDirective
  ],
  templateUrl: './activity-host.component.html',
  styleUrl: './activity-host.component.scss'
})
export class ActivityHostComponent {

  public readonly activity = input.required<ActivityDTO | null>();
  public readonly hostUrl = input.required<string>();
  public readonly isPreview = input.required<boolean>();

  private readonly scrollManager = inject(ScrollManagerService);

  public readonly host = computed(() => this.activity()?.mainHost);

  public readonly SECTION_SEND_MESSAGE = 'section-message';
  public readonly showMessaging = computed(() => !!this.host()?.messaging);
  public showContact = signal(false);
  public toggleShowContact(): void {
    this.showContact.update(val => !val);
    if (this.showContact()) {
      this.scrollManager.scroll(this.SECTION_SEND_MESSAGE);
    }
  }

  public readonly icons = {
    host: HouseIcon,
    externalLink: ExternalLinkIcon,
    message: MessageSquareMoreIcon
  };

  public readonly socialLabels = {
    web: 'web',
    fb: 'facebook',
    ig: 'instagram'
  }

}
